import type { SelectableCardSize } from './type';

export const BORDER_RADIUS = 8;
export const BORDER_WIDTH = 2;

export const PADDING_BY_SIZE: Record<SelectableCardSize, number> = {
  sm: 13,
  md: 20,
  lg: 20,
};

export const ICON_SIZE: Record<SelectableCardSize, number> = {
  sm: 13,
  md: 20,
  lg: 30,
};

export const ICON_MARGIN_RIGHT_BY_SIZE: Record<SelectableCardSize, number> = {
  sm: 5,
  md: 10,
  lg: 0,
};

export const ICON_MARGIN_BOTTOM_BY_SIZE: Record<SelectableCardSize, number> = {
  sm: 0,
  md: 0,
  lg: 10,
};
